<template>
  <div>
    <div class="table-responsive">
      <br />

      <div v-if="traffic_light.length > 0">
        <div class="card-header card-header-primary negative rounded-0 blue-grad w-50 pl-0" v-if="mode !== 'pdf'">
          <h4 style="
              font-family: &quot;Roboto&quot;;
              font-style: normal;
              font-weight: 400;
              font-size: 20px;
              line-height: 24px;
              display: flex;
              align-items: center;
              color: #333333;
            ">
            Результаты поиска ({{ traffic_light.length }})
          </h4>
        </div>
        <!-- <br> -->
        <div class="table-responsive-mobile">
        <b-table :fixed="true" :fields="fuzzy_business_list_fields" :items="traffic_light">
          <template v-slot:cell(Name)="data">
            <div>{{ data.value }}</div>
            <button v-if="mode !== 'pdf'"
              class="btn btn-secondary d-flex text-nowrap align-items-center gap-3 mt-3 btn-sm"
              @click="getInformation(data.item)">
              {{ $t("message.order_group_search") }}
              <svg class="ml-2" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M10 2C9.44772 2 9 2.44772 9 3V5H3C2.44772 5 2 5.44772 2 6V17C2 19.7614 4.23858 22 7 22H17C19.7614 22 22 19.7614 22 17V3C22 2.44772 21.5523 2 21 2H10ZM4 7H9V16C9 16.5523 8.55228 17 8 17H7C6.44772 17 6 17.4477 6 18C6 18.5523 6.44772 19 7 19H8C9.65685 19 11 17.6569 11 16V6V4H20V17C20 18.6569 18.6569 20 17 20H7C5.34315 20 4 18.6569 4 17V7ZM13 6C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H18C18.5523 8 19 7.55228 19 7C19 6.44772 18.5523 6 18 6H13ZM12 11C12 10.4477 12.4477 10 13 10H18C18.5523 10 19 10.4477 19 11C19 11.5523 18.5523 12 18 12H13C12.4477 12 12 11.5523 12 11ZM13 14C12.4477 14 12 14.4477 12 15C12 15.5523 12.4477 16 13 16H18C18.5523 16 19 15.5523 19 15C19 14.4477 18.5523 14 18 14H13Z"
                  fill="white" />
              </svg>
            </button>
          </template>
          <template v-slot:cell(grade)="data">
            <div @click="loadTrafficLightDetails(data.item)"
              v-tippy="{ arrow: true, theme: 'light-border', maxWidth: 480 }" :content="data.item.as_calculated_grade"
              :class="[
                'rounded-circle traffic-light-pin',
                checkTrafficLight(data),
              ]">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(Status)="data">
            <!-- {{ translateStatuses(data.value) }} -->
            {{ data.value }}
          </template>
        </b-table>
        </div>
      </div>
      <!-- <div v-if="mode !=='pdf'  && mode !=='history' && Paging.TotalRecords > response_info.length" class="text-center">
                                <button class="btn btn-primary btn-sm" @click="loadMoreData()">{{loadMoreDataLabel()}}</button>
                            </div> -->
      <!-- <div v-if="loading_new_page >= 0 && loading_new_page!==3" style="position: relative; height: 100px;width: 100%;">
                                <div class="row">
                                    <div class="col-md-2"></div>
                                    <div class="col-md-8"> <b-progress :value="loading_new_page" :max="3" show-progress animated></b-progress></div>
                                </div>
                                <div class="text-center">{{timer_minutes_new_page}}:{{timer_seconds_new_page}}</div>
                                <div class="text-center"> {{$t('message.find_partner.load_in_progress')}}</div>
                                <div class="text-center" v-if="loading_new_page == 1"> {{$t('message.find_partner.services_loading_data')}}</div>
                                <div class="text-center" v-if="loading_new_page == 2"> {{$t('message.find_partner.services_loading_translations')}}</div>
                                <div class="text-center" v-if="loading_new_page == 3"> {{$t('message.find_partner.services_rendering')}}</div>

                                
                            </div> -->
      <div v-if="search_company_info_complete && loading == 3" class="w-100">
        <div class="align-items-sm-start d-flex flex position-relative w-100" style="height: 90px; padding-top: 15px">
          <!-- <send-email :selected_search_results="[tmp_for_helpers]" />  -->
          <!-- <ca-check :selected_search_results="[tmp_for_helpers]" />  -->
          <pdf :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters" :goods="service_code" :doc_id="0"
            source="main-service-cn"></pdf>
        </div>
      </div>
    </div>
    <div v-if="resultsEmpty">
      <div class="card">
        <div class="card-body">
          <div class="position-relative">
            <h2 class="text-center">
              Attis {{ $t("message.find_partner.find_partner") }}
            </h2>
          </div>
          <h4 class="text-center">
            {{ $t("message.find_partner.search_certificate") }}
          </h4>

          <div class="text-left">
            {{ $t("message.find_partner.request_date") }}: {{ momentum_now() }}
            <!-- {{ no_results_report.content.data.created_at }} -->
          </div>
          <!-- <div class="text-left">
                                            Нечеткость: 
                                            {{ no_results_report.content.data.filters.fuzziness }}%
                                        </div> -->
          <!-- <div>
                                            Типы: <span class="badge border-primary border text-primary mr-2 mb-2" v-for="type in no_results_report.content.data.filters.types">{{ type }}</span>
                                        </div> -->
          <div class="text-left">
            {{ $t("message.find_partner.no_matches_line") }}
          </div>
          <!-- <div>
                                            Уровень риска: {{ no_results_report.content.data.risk_level }}
                                        </div> -->
          <h4 class="mt-3 text-left">
            {{ $t("message.find_partner.search_results") }}
          </h4>
          <div class="text-left" style="border: 1px solid #ccc; padding: 15px; border-radius: 5px">
            {{ $t("message.find_partner.found_matches") }}:
            <span class="badge bg-primary"> 0 </span>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="modal-details" hide-footer :title="$t('message.find_partner.group_search')" size="xl">
      <div class="row-">
        <!-- <div v-if="loading!==3" style="position: relative; height: 100px;width: 100%;">
                     <div class="row">
                        <div class="col-md-2"></div>
                        <div class="col-md-8"> <b-progress :value="loading" :max="3" show-progress animated></b-progress></div>
                    </div> 
                    <div class="text-center">{{timer_minutes}}:{{timer_seconds}}</div>
                    <div class="text-center"> {{$t('message.find_partner.load_in_progress')}}</div>
                    <div class="text-center" v-if="loading == 1"> {{$t('message.find_partner.services_loading_data')}}</div>
                    <div class="text-center" v-if="loading == 2"> {{$t('message.find_partner.services_loading_translations')}}</div>
                    <div class="text-center" v-if="loading == 3"> {{$t('message.find_partner.services_rendering')}}</div>

                    
                </div> -->
        <div v-if="search_company_info_complete && loading == 3" class="w-100">
          <div class="align-items-sm-start d-flex flex position-relative w-100" style="height: 90px; padding-top: 15px">
            <!-- <send-email :selected_search_results="[tmp_for_helpers]" />  -->
            <!-- <ca-check :selected_search_results="[tmp_for_helpers]" />  -->
            <pdf :user_id="0" :document="pdf_document" :doc_additional="pdf_parameters" :goods="service_code" :doc_id="0"
              source="main-service-cn"></pdf>
          </div>
        </div>

        <!-- <tmp-company-info-service-cn v-if="search_company_info_complete && loading==3"  :data=company_info_data></tmp-company-info-service-cn> -->
        <overallSearchCnEmbed :keyword_input="keyWord" :price="overall_search_price" v-if="show_overall_search" />
      </div>
    </b-modal>
    <b-modal id="traffic-light-details" hide-footer :title="$t('message.more')" size="xl">
      <div class="row p-3 mx-0 mb-3 border rounded" v-if="current_traffic_light_details">
        <div class="bg-light col-2 mb-3 p-3 rounded">
          <div class="text-sm text-muted mb-1">
            {{ $t("message.find_partner.common_info_Grade") }}
          </div>
          <span class="display-4 font-weight-bold">{{
            current_traffic_light_details.grade
          }}</span>
          <div>
            <small><a href="#how-is-calculated" style="text-decoration: none; border-bottom: 1px dashed">{{
              $t("message.find_partner.common_info_as_calculated_grade")
            }}</a></small>
          </div>
        </div>
        <div class="col-10 mb-3">
          <div class="text-sm text-muted mb-1">
            {{ $t("message.find_partner.common_info_GradeDescription") }}
          </div>
          {{ current_traffic_light_details.grade_description }}
        </div>
      </div>
      <div class="row" v-if="current_traffic_light_details">
        <div class="col-4">
          <div class="text-sm text-muted mb-1">
            {{ $t("message.find_partner.common_info_EconKind") }}
          </div>
          {{
            current_traffic_light_details.EconKind
            ? current_traffic_light_details.EconKind
            : "–"
          }}

          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_BelongOrg") }}
          </div>
          {{
            current_traffic_light_details.BelongOrg
            ? current_traffic_light_details.BelongOrg
            : "–"
          }}
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_OperName") }}
          </div>
          {{
            current_traffic_light_details.OperName
            ? current_traffic_light_details.OperName
            : "–"
          }}
        </div>
        <div class="col-4">
          <div class="text-sm text-muted mb-1">
            {{ $t("message.find_partner.common_info_Name") }}
          </div>
          {{
            current_traffic_light_details.Name
            ? current_traffic_light_details.Name
            : "–"
          }}

          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_No") }}
          </div>
          {{
            current_traffic_light_details.No
            ? current_traffic_light_details.No
            : "–"
          }}

          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_OrgNo") }}
          </div>
          {{
            current_traffic_light_details.OrgNo
            ? current_traffic_light_details.OrgNo
            : "–"
          }}
        </div>
        <div class="col-4">
          <img :src="current_traffic_light_details.ImageUrl" alt=""
            v-if="current_traffic_light_details.ImageUrl !== ''" />
        </div>
      </div>
      <div class="row" v-if="current_traffic_light_details">
        <div class="col-4">
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_StartDate") }}
          </div>
          {{
            current_traffic_light_details.StartDate
            ? current_traffic_light_details.StartDate
            : "–"
          }}
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_Status") }}
          </div>
          <span v-if="current_traffic_light_details.Status">{{
            translateStatuses(current_traffic_light_details.Status)
          }}</span>
        </div>
        <div class="col-4">
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_UpdatedDate") }}
          </div>
          {{
            current_traffic_light_details.UpdatedDate
            ? current_traffic_light_details.UpdatedDate
            : "–"
          }}
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_CreditCode") }}
          </div>
          {{
            current_traffic_light_details.CreditCode
            ? current_traffic_light_details.CreditCode
            : "–"
          }}
        </div>
        <div class="col-4">
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_EndDate") }}
          </div>
          {{
            current_traffic_light_details.EndDate
            ? current_traffic_light_details.EndDate
            : "–"
          }}
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_RegistCapi") }}
          </div>
          {{
            current_traffic_light_details.RegistCapi
            ? current_traffic_light_details.RegistCapi
            : "–"
          }}
        </div>
      </div>
      <div class="row" v-if="current_traffic_light_details">
        <div class="col-4">
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_Province") }}
          </div>
          {{
            current_traffic_light_details.Province
            ? current_traffic_light_details.Province
            : "–"
          }}
        </div>
        <div class="col-8">
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_Address") }}
          </div>
          {{
            current_traffic_light_details.Address
            ? current_traffic_light_details.Address
            : "–"
          }}
        </div>
      </div>
      <div class="row" v-if="current_traffic_light_details">
        <div class="col-12">
          <div class="text-sm text-muted mb-1 mt-2">
            {{ $t("message.find_partner.common_info_Scope") }}
          </div>
          {{
            current_traffic_light_details.Scope
            ? current_traffic_light_details.Scope
            : "–"
          }}
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-12" id="how-is-calculated">
          <hr />
          <div class="text-lg font-bolder font-weight-bolder text-bolder mb-1">
            {{ $t("message.find_partner.common_info_as_calculated_grade") }}
          </div>
          {{ current_traffic_light_details.as_calculated_grade }}
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import moment from "moment";
import overallSearchCnEmbed from "./overall-search-cn-embed.vue";
export default {
  props: ["data", "progress", "mode", "traffic_light", "mode"],
  components: { overallSearchCnEmbed },

  data() {
    return {
      search_company_info_complete: false,
      keyWord: "",
      loading: -1,
      loading_new_page: -1,
      pdf_parameters: {},
      pdf_document: {},
      tmp_for_helpers: {
        name: "",
        email: "",
      },
      service_code: [],
      company_info_data: {
        response_info: {},
        service_info: {},
        areaList: [],
        industryList: [],
        revokeInfoList: [],
        parentInfoList: [],

        UsedNameList: [],
        ShareHolderList: [],
        EmployeeList: [],
        InvestList: [],
        ChangeList: [],
        BranchList: [],
        MoreEmailList: [],
        EntTagList: [],
      },
      response_info: [],
      fuzzy_business_list_fields: [
        // {
        //     key: 'KeyNo',
        //     label: this.$t('message.find_partner.fuzzy_search_cn_KeyNo'),
        // },
        {
          key: "grade",
          label: this.$t("message.find_partner.rating_410"),
          thStyle: { width: "80px" },
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.fuzzy_search_cn_Name"),
        },
        {
          key: "CreditCode",
          label: this.$t("message.find_partner.fuzzy_search_cn_CreditCode"),
        },
        {
          key: "StartDate",
          label: this.$t("message.find_partner.fuzzy_search_cn_StartDate"),
        },
        {
          key: "OperName",
          label: this.$t("message.find_partner.fuzzy_search_cn_OperName"),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.fuzzy_search_cn_Status"),
          sortable: true,
        },
        {
          key: "No",
          label: this.$t("message.find_partner.fuzzy_search_cn_No"),
        },
        {
          key: "Address",
          label: this.$t("message.find_partner.fuzzy_search_cn_Address"),
        },
        // {
        //     key: 'action',
        //     label: "",
        // },
      ],
      timer_seconds: "00",
      timer_minutes: "00",
      interval: "",
      Paging: {},
      currency: "",
      price: 0,
      timer_seconds_new_page: "00",
      timer_minutes_new_page: "00",
      interval_new_page: "",

      show_overall_search: false,
      overall_search_price: 0,

      current_traffic_light_details: {},
    };
  },
  mounted() {
    this.response_info = this.data.response_info;
    this.Paging = this.data.Paging;
    this.currency = this.data.currency;
    this.price = this.data.price;
  },
  computed: {
    resultsEmpty() {
      return this.traffic_light.length == 0; //Object.keys(this.response_info).length==0
    },
  },
  watch: {
    data: function (newVal, oldVal) {
      this.response_info = newVal.response_info;
      if (newVal.Paging) this.Paging = newVal.Paging;
    },
    progress: function (newVal, oldVal) {
      console.log("progress fuzzy", oldVal, newVal);
      this.loading_new_page = newVal;
    },
    loading: function (newVal, oldVal) {
      if (oldVal < 3 && newVal >= 3) {
        clearInterval(this.interval);
      }
    },
    loading_new_page: function (newVal, oldVal) {
      if (oldVal < 3 && newVal >= 3) {
        clearInterval(this.interval_new_page);
      }
    },
  },
  methods: {
    /**
     * Translates string of company statuses
     * @param {*} string
     */
    translateStatuses(string) {
      const translations = {
        存续: this.$t("message.contragent_search.company_info_status_1"),
        开业: this.$t("message.contragent_search.company_info_status_1"),
        在业: this.$t("message.contragent_search.company_info_status_1"),
        在营: this.$t("message.contragent_search.company_info_status_1"),
        正常: this.$t("message.contragent_search.company_info_status_1"),
        经营: this.$t("message.contragent_search.company_info_status_1"),
        在册: this.$t("message.contragent_search.company_info_status_1"),
        在营在册: this.$t("message.contragent_search.company_info_status_1"),
        有效: this.$t("message.contragent_search.company_info_status_1"),
        在业在册: this.$t("message.contragent_search.company_info_status_1"),

        迁出: this.$t("message.contragent_search.company_info_status_2"),

        吊销: this.$t("message.contragent_search.company_info_status_3"),
        未注销: this.$t("message.contragent_search.company_info_status_3"),

        注销: this.$t("message.contragent_search.company_info_status_4"),

        停业: this.$t("message.contragent_search.company_info_status_5"),

        清算: this.$t("message.contragent_search.company_info_status_6"),

        "、": ", ",
      };
      for (const key in translations) {
        let value = translations[key];
        string = string.replaceAll(key, value);
      }
      return string;
    },
    loadTrafficLightDetails(item) {
      this.current_traffic_light_details = item;
      this.$bvModal.show("traffic-light-details");
      // axios.get(window.base + '/library/getAdvancedResult?id='+item.log_id).then(response=>{
      //     this.current_traffic_light_details = response.data
      //     this.current_traffic_light_details.data_cn = JSON.parse(this.current_traffic_light_details.data_cn)
      //     this.current_traffic_light_details.data_ru = JSON.parse(this.current_traffic_light_details.data_ru)
      //     if(this.current_traffic_light_details.data_ru && this.current_traffic_light_details.data_ru.Result && this.current_traffic_light_details.data_ru.Result.EconKind)
      //         this.current_traffic_light_details.data_ru.Result.EconKind = JSON.parse(this.current_traffic_light_details.data_ru.Result.EconKind)
      //     if(this.current_traffic_light_details.data_ru && this.current_traffic_light_details.data_ru.Result && this.current_traffic_light_details.data_ru.Result.Address)
      //         this.current_traffic_light_details.data_ru.Result.Address = JSON.parse(this.current_traffic_light_details.data_ru.Result.Address)
      //     if(this.current_traffic_light_details.data_ru && this.current_traffic_light_details.data_ru.Result && this.current_traffic_light_details.data_ru.Result.Scope)
      //         this.current_traffic_light_details.data_ru.Result.Scope = JSON.parse(this.current_traffic_light_details.data_ru.Result.Scope)
      //     this.$bvModal.show('traffic-light-details')
      // })
    },
    checkTrafficLight(data) {
      let traffic_light_tmp = data.item.grade;
      if (traffic_light_tmp <= 80) return "bg-danger";
      if (traffic_light_tmp > 80 && traffic_light_tmp <= 100)
        return "bg-warning";
      if (traffic_light_tmp > 100) return "bg-success";
      // return traffic_light_tmp.grade
    },
    momentum_now(d) {
      return moment().format("D.MM.Y");
    },
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    getInformation(data) {
      if (data.CreditCode != "") this.keyWord = data.CreditCode;
      else if (data.No != "") this.keyWord = data.No;
      else this.keyWord = data.Name;

      axios
        .get(window.base + "/account/GetServicesPrice")
        .then(async (response) => {
          let sum = 0;
          let cur = "";
          await response.data.forEach((item) => {
            if (
              ["430", "930", "701", "213", "736"].includes(
                item.billing_service_code,
              )
            ) {
              if (this.$store.state.user.is_privileged)
                sum += item.service_price_privileged;
              else sum += item.billing_service_price;

              cur = item.billing_service_cur;
            }
          });
          this.$bvModal
            .msgBoxConfirm(
              this.$t("message.find_partner.cn_company_info_check_alert") +
              " " +
              sum +
              " " +
              cur,
              {
                title: this.$t("message.confirm"),
                size: "md",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.$t("message.yes"),
                cancelTitle: this.$t("message.no"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              },
            )
            .then((value) => {
              if (value) {
                this.loading = 0;
                this.show_overall_search = true;
                this.overall_search_price = sum;
                // this.searchCompanyInfo()
                this.$bvModal.show("modal-details");
              }
            });
        });
      // axios.get(window.base+'/admin/GetBillingServiceInfo?code=430')
      // 	.then(response=>{
      // 		this.$bvModal.msgBoxConfirm(this.$t('message.find_partner.cn_company_info_check_alert') + ' ' + response.data.billing_service_price + ' ' + response.data.billing_service_cur, {
      // 			title: this.$t('message.confirm'),
      // 			size: 'sm',
      // 			buttonSize: 'sm',
      // 			okVariant: 'danger',
      // 			okTitle: this.$t('message.yes'),
      // 			cancelTitle: this.$t('message.no'),
      // 			footerClass: 'p-2',
      // 			hideHeaderClose: false,
      // 			centered: true
      // 			}).then(value => {
      // 				if(value){
      //                     this.loading = 0
      //                     this.searchCompanyInfo()
      //                     this.$bvModal.show('modal-details')
      //                 }
      //             })
      //         })
    },
    logServiceRequest(service_code, search_text, result) {
      var requestlog = {};
      requestlog.service_code = service_code;
      requestlog.search_text = search_text;
      requestlog.result = JSON.stringify(result);

      axios
        .post(window.base + "/contract/saveContrHistory", requestlog)
        .then((ter) => { });
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextArray?source=zh&target=" +
          locale,
          text,
        );
      }
    },
    async formatObjects(object, list) {
      return this.translateTextArray(object).then((res) => {
        for (let i = 0; i < res.data.length; i++) {
          list[i].push(JSON.parse(res.data[i]).translation);
        }
        this.company_info_data.service_info = list;
      });
    },
    // formats table data with translations
    async formatObjectTablesCompany(object, list) {
      if (object) {
        var keys = Object.keys(object);
        var values = Object.values(object);
        return this.translateTextArray(values)
          .then((res) => {
            res.data.forEach((t, i) => {
              list.push({
                Key: keys[i],
                Translated: JSON.parse(t).translation,
                Original: values[i],
              });
            });
          })
          .catch((e) => {
            console.log("catch formatObjectTables", e);
            console.log(object);
            return false;
          });
      } else return true;
    },
    async formatArrayObjectTables(object, list) {
      if (object.length > 0) {
        await object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          this.translateTextArray(values)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                translated[keys[j]] = JSON.parse(res.data[j]).translation;
              }
              list.push(translated);
            })
            .catch(() => {
              console.log("catch formatArrayObjectTables");
              return false;
              console.log("error translating...");
            });
        });
      } else return true;
    },
    async makeBulkTranslation({ objects, tables, object_tables, strings }) {
      console.warn("bulk input", objects, tables, object_tables);
      const request = [];
      const request_tmp = [];
      if (typeof objects[0] !== "undefined") {
        objects.forEach((item) => request.push(Object.values(item).map(item => {
          if (typeof item != 'object') {
            return item;
          } else {
            return "";
          }
        })));
      }
      if (typeof tables[0] !== "undefined") {
        tables.forEach((item) => {
          const values = Object.values(item).map(item => {
            if (typeof item != 'object') {
              return item;
            } else {
              return "";
            }
          });
          if (values.length > 0) request.push(values);
        });
      }
      if (typeof object_tables[0] !== "undefined") {
        object_tables.forEach((table) => {
          if (Array.isArray(table)) {
            table.forEach((object) => {
              const values = Object.values(object).map(item => {
                if (typeof item != 'object') {
                  return item;
                } else {
                  return "";
                }
              });
              if (values.length > 0) request.push(values);
            });
          }
        });
      }
      if (typeof strings[0] !== "undefined") {
        strings.forEach((object) => {
          request.push(object.stringValues);
        });
      }

      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        const objects_translated = [];
        const tables_translated = [];
        const object_tables_translated = [];

        const response = await axios.post(
          window.base +
          "/library/TranslateNextMultiArray?source=zh&target=" +
          locale,
          request,
        ); //.then(response=>{
        let global_counter = 0;

        const data = response.data;
        console.log(request, data);
        if (typeof objects[0] !== "undefined") {
          objects.forEach((item, index) => {
            objects_translated.push(
              response.data[global_counter].map(
                (translated) => JSON.parse(translated).translation,
              ),
            );
            global_counter++;
          });
        }
        if (typeof tables[0] !== "undefined") {
          tables.forEach((item, index) => {
            const values = Object.values(item);
            if (values.length > 0) {
              const keys = Object.keys(item);
              console.log("kekekey", keys);
              const translated_object = [];
              // keys.forEach((key, key_index)=>{
              response.data[global_counter].forEach((t, i) => {
                if (
                  keys[i] === "CreditCode" ||
                  keys[i] === "No" ||
                  keys[i] === "IndustryCode" ||
                  keys[i] === "SubIndustryCode" /*|| keys[i]=='Year'*/ ||
                  keys[i] == "PublishDate"
                ) {
                  translated_object.push({
                    Key: keys[i],
                    Translated: values[i],
                    Original: values[i],
                  });
                } else {
                  translated_object.push({
                    Key: keys[i],
                    Translated: JSON.parse(t).translation,
                    Original: values[i],
                  });
                }
              });
              // })
              global_counter++;
              tables_translated.push(translated_object);
            } else {
              tables_translated.push(item);
            }
          });
        }
        console.log("tables_translated", tables_translated);
        console.log("ot", object_tables);
        if (typeof object_tables[0] !== "undefined") {
          object_tables.forEach((object) => {
            const translated_object_table = [];
            console.log("objt", object);
            if (Array.isArray(object)) {
              object.forEach((item) => {
                const values = Object.values(item);
                console.warn(
                  "trans",
                  global_counter,
                  response.data[global_counter],
                );
                if (values.length > 0) {
                  const keys = Object.keys(item);
                  const translated_object = {};
                  keys.forEach((key, key_index) => {
                    console.log("keyj", key);
                    if (
                      typeof response.data[global_counter] !== "undefined" &&
                      Array.isArray(response.data[global_counter])
                    )
                      if (
                        typeof response.data[global_counter][key_index] !==
                        "undefined"
                      ) {
                        try {
                          translated_object[key] = JSON.parse(
                            response.data[global_counter][key_index],
                          ).translation;
                        } catch (e) {
                          console.log(e)
                        }
                      }
                  });

                  translated_object_table.push(translated_object);
                } else {
                  translated_object_table.push(item);
                }
                global_counter++;
              });
            }
            object_tables_translated.push(translated_object_table);
          });
        }
        console.log("ot_", object_tables_translated);
        const strings_translated = [];
        if (typeof strings[0] !== "undefined") {
          strings.forEach((object) => {
            const tmp_object = {};

            object.stringKeys.forEach((key, i) => {
              if (Array.isArray(response.data[global_counter]))
                tmp_object[key] = JSON.parse(
                  response.data[global_counter][i],
                ).translation;
            });
            strings_translated.push(tmp_object);
            global_counter++;
          });
        }

        console.warn(
          objects_translated.length,
          tables_translated.length,
          object_tables_translated.length,
        );
        return {
          objects: objects_translated,
          tables: tables_translated,
          object_tables: object_tables_translated,
          strings: strings_translated,
        };
        // })
      }
      return { objects, tables, object_tables, strings };
    },

    async getCompanyInfoTranslations(
      service_to_translate,
      tmp_service_info,
      tmp_response_info,
    ) {
      return new Promise(async (resolve, reject) => {
        const {
          objects: [service_info],
          tables: [areaList, industryList, revokeInfoList, parentInfoList],
          object_tables: [
            EntTagList,
            ChangeList,
            UsedNameList,
            ShareHolderList,
            EmployeeList,
            InvestList,
            BranchList,
            MoreEmailList,
          ],
        } = await this.makeBulkTranslation({
          objects: [service_to_translate],
          tables: [
            tmp_response_info.Area,
            tmp_response_info.Industry,
            tmp_response_info.RevokeInfo,
            tmp_response_info.ParentInfo,
          ],
          object_tables: [
            tmp_response_info.EntTagList,
            tmp_response_info.ChangeList,
            tmp_response_info.UsedNameList,
            tmp_response_info.ShareHolderList,
            tmp_response_info.EmployeeList,
            tmp_response_info.InvestList,
            tmp_response_info.BranchList,
            tmp_response_info.MoreEmailList,
          ],
          strings: [],
        });
        // console.log(data)
        let real_service_info = [];
        real_service_info = tmp_service_info.map((item, index) => {
          return [item[0], item[1], service_info[index]];
          // return item
        });
        // 91110105599635386M

        this.$set(this.company_info_data, "service_info", real_service_info);
        this.$set(this.company_info_data, "areaList", areaList);
        this.$set(this.company_info_data, "industryList", industryList);
        this.$set(this.company_info_data, "revokeInfoList", revokeInfoList);
        this.$set(this.company_info_data, "parentInfoList", parentInfoList);

        this.$set(this.company_info_data, "EntTagList", EntTagList);
        this.$set(this.company_info_data, "ChangeList", ChangeList);
        this.$set(this.company_info_data, "UsedNameList", UsedNameList);
        this.$set(this.company_info_data, "ShareHolderList", ShareHolderList);
        this.$set(this.company_info_data, "EmployeeList", EmployeeList);
        this.$set(this.company_info_data, "InvestList", InvestList);
        this.$set(this.company_info_data, "BranchList", BranchList);
        this.$set(this.company_info_data, "MoreEmailList", MoreEmailList);
        resolve();
      });
    },

    searchCompanyInfo() {
      this.pdf_parameters.keyWord = this.keyWord;
      this.pdf_parameters.keyWord886 = "";
      this.pdf_parameters.provinceCode = "";
      this.pdf_parameters.cityCode = "";
      axios.get(window.base + "/document/getfirmfull").then((response) => {
        if (response.data.persons) {
          this.pdf_parameters.searcher_full_name =
            response.data.persons.given_name +
            " " +
            response.data.persons.middle_name +
            " " +
            response.data.persons.last_name;
        }
      });
      this.startTimer();
      this.loading = 1;
      axios
        .get("https://attistrade.cn/library/openAPIQCC?keyWord=" + this.keyWord)
        .then((response) => {
          this.logServiceRequest("430", this.keyWord, response.data);
          this.loading = 2;
          if (response.data.Result == null) {
            this.loading = 3;
            new Noty({
              theme: "light",
              type: "warning",
              text: this.$t("message.find_partner.data_is_not_found")
                .replace("{x}", this.$t("message.find_partner.common_info_cn"))
                .replace("{y}", this.keyWord),
              timeout: 5000,
            }).show();
            return;
          }
          this.no_result = false;
          var tmp_response_info = response.data.Result;

          this.tmp_for_helpers.name = response.data.Result.Name;
          this.tmp_for_helpers.email = response.data.Result.Email;

          this.tmp_company_info_for_helpers = response.data.Result;

          // transform change list data
          if (tmp_response_info.ChangeList.length > 0) {
            tmp_response_info.ChangeList.forEach((chg) => {
              if (typeof chg.BeforeList !== "string")
                chg.BeforeList = chg.BeforeList.join(",");
              if (typeof chg.AfterList !== "string")
                chg.AfterList = chg.AfterList.join(",");
            });
          }

          var tmp_service_info = Object.entries(response.data.Result);

          tmp_service_info = tmp_service_info.filter(
            (item) =>
              typeof item[1] !== "object" && !_.isArray(item[1]) && item[1],
          );

          // Translating packages of text (columns of tables)
          var service_to_translate = [];
          tmp_service_info.forEach(([key, value]) => {
            service_to_translate.push(value);
          });

          this.getCompanyInfoTranslations(
            service_to_translate,
            tmp_service_info,
            tmp_response_info,
          ).then((r) => {
            this.no_result = false;
            this.loading = 3;

            console.log("company 1");

            this.search_company_info_complete = true;
            this.company_info_data.response_info = tmp_response_info;
            this.pdf_document.company_info_data = this.company_info_data;
            this.service_code = ["430"];
          });
        })
        .catch((e) => {
          console.log(e);
          this.loading = 3;
          new Noty({
            theme: "light",
            type: "error",
            text:
              this.$t("message.find_partner.error_loading_service").replace(
                "{}",
                this.$t("message.find_partner.common_info_cn"),
              ) + this.keyWord,
            timeout: 5000,
          }).show();
        });
    },
    startTimer() {
      var sec = 0;
      this.interval = setInterval(() => {
        this.timer_seconds = this.pad(++sec % 60);
        this.timer_minutes = this.pad(parseInt(sec / 60, 10));
      }, 1000);
    },
    startTimerNewPage() {
      var sec = 0;
      this.interval_new_page = setInterval(() => {
        this.timer_seconds_new_page = this.pad(++sec % 60);
        this.timer_minutes_new_page = this.pad(parseInt(sec / 60, 10));
      }, 1000);
    },
    pad(val) {
      return val > 9 ? val : "0" + val;
    },
    loadMoreDataLabel() {
      let load_next_count = 0;
      let diff = this.Paging.TotalRecords - this.response_info.length;
      if (diff >= this.Paging.PageSize) load_next_count = this.Paging.PageSize;
      else load_next_count = diff;
      return this.$t("message.find_partner.fuzzy_load_more_results").replace(
        "{}",
        load_next_count,
      );
    },
    loadMoreData() {
      let message =
        this.$t("message.find_partner.cn_single_service_alert").replace(
          "{}",
          this.$t("message.find_partner.fuzzy_search_cn"),
        ) +
        " " +
        this.price +
        " " +
        this.currency;
      this.$bvModal
        .msgBoxConfirm(message, {
          title: this.$t("message.confirm"),
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: this.$t("message.yes"),
          cancelTitle: this.$t("message.no"),
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then(async (value) => {
          if (value) {
            let fd = new FormData();
            if (isNaN(this.price)) this.price = 0;
            fd.append("amount", this.price);
            fd.append("service_code", "886");
            fd.append("search_keyword", this.keyWord);
            this.reduceBalanceData = (await axios.post(window.base + "/account/reduceBalance", fd)).data;
            const reduceBalanceId = this.reduceBalanceData?.id || null;
                    
            if (this.reduceBalanceData?.isAccountBalanceLow) {
              this.$bvModal.msgBoxOk(this.$t("message.message.account_balance_is_low", { balance: window.rubFormat(this.reduceBalanceData.accountBalance, this.currency) }), {
                title: this.$t("message.confirm"),
                size: "md",
                buttonSize: "sm",
                okVariant: "success",
                okTitle: this.$t("message.ok"),
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
              });
            }
            
            this.$root.$emit("reduceBalance", { price: this.price });
            this.startTimerNewPage();
            this.loading_new_page = 0;
            this.$root.$emit("load-fuzzy-new-page", reduceBalanceId);
          }
        });
    },
  },
};
</script>
<style>
.traffic-light-pin {
  width: 20px;
  height: 20px;
  margin-top: 10px;
  margin-left: -5px;
  font-size: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
}
</style>

<style scoped>
@media (max-width: 768px) {
  .table-responsive-mobile {
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    min-width: 700px;
  }
  
}
</style>